// src/pages/GestorNovo.js

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AdminLayout from "../components/AdminLayout";

function GestorNovo() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    telefone_gestor: "",
    email_gestor: "",
    nome_gestor: "",
    cargo_gestor: "",
    matricula_gestor: "",
    portaria_gestor: "",
    edicao_gestor: "",
    pagina_gestor: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    let formattedValue = value;

    if (name === "email_gestor") {
      setEmailError(validateEmail(value) ? "" : "Email inválido");
    }

    if (name === "telefone_gestor") {
      formattedValue = formatTelefone(value);
    }
    
    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };
  
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);  // Define como enviando

    // Remova a formatação do telefone antes do envio
  const formDataToSend = {
    ...formData,
    telefone_gestor: formData.telefone_gestor.replace(/[^\d]/g, ""), // Remove formatação do telefone
  };

    try {
        const response = await fetch(`${API_BASE_URL}gestor/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formDataToSend),
        });

        if (response.ok) {
            setSuccessMessage("Gestor cadastrado com sucesso!");
            setFormData({  // Limpa os campos do formulário
              telefone_gestor: "",
              email_gestor: "",
              nome_gestor: "",
              cargo_gestor: "",
              matricula_gestor: "",
              portaria_gestor: "",
              edicao_gestor: "",
              pagina_gestor: "",
            });
            
            setTimeout(() => {
                setSuccessMessage("");  // Oculta a mensagem de sucesso após alguns segundos
                navigate("/gestor");  // Redireciona para a página de monitoramento
            }, 3000);  // Ajuste o tempo para controlar o intervalo de exibição da mensagem
        } else {
          setErrorMessage("Falha ao cadastrar gestor.");
      }
        } catch (error) {
            setErrorMessage("Ocorreu um erro ao enviar o formulário.");
        } finally {
            setIsSubmitting(false);  // Libera o formulário após o término
        }
    };

  useEffect(() => {
    if (successMessage || errorMessage) {
        const timer = setTimeout(() => {
            setSuccessMessage("");
            setErrorMessage("");
        }, 5000); // 5 segundos
        return () => clearTimeout(timer);
    }
}, [successMessage, errorMessage]);

  return (
    <AdminLayout>
      <div>
          {successMessage && (
              <div className="alert alert-success alert-float">
                  {successMessage}
              </div>
          )}
          {errorMessage && (
              <div className="alert alert-danger alert-float">
                  {errorMessage}
              </div>
          )}
      </div>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit} disabled={isSubmitting}>
            <div className="card-body">
              <h3 className="card-title">Cadastro de Gestor</h3>
              <div className="row row-cards">
                {/* Identificação do Gestor */}
                <h4 className="mt-4">1. Informações do Gestor</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input type="text" className="form-control" name="nome_gestor" onChange={handleChange} value={formData.nome_gestor} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Cargo</label>
                    <input type="text" className="form-control" name="cargo_gestor" onChange={handleChange} value={formData.cargo_gestor} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Matrícula</label>
                    <input type="text" className="form-control" name="matricula_gestor" onChange={handleChange} value={formData.matricula_gestor} />
                  </div>
                </div>
                {/* Telefone e Email */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefone_gestor"
                      onChange={handleChange}
                      value={formData.telefone_gestor}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email_gestor"
                      onChange={handleChange}
                      value={formData.email_gestor}
                    />
                    {emailError && (
                      <small className="text-danger">{emailError}</small>
                    )}
                  </div>
                </div>
                {/* Portaria Edição e Pagina */}
                <h4 className="mt-4">2. Informações da Portaria</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Portaria</label>
                    <input type="text" className="form-control" name="portaria_gestor" onChange={handleChange} value={formData.portaria_gestor} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Edição</label>
                    <input type="text" className="form-control" name="edicao_gestor" onChange={handleChange} value={formData.edicao_gestor} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Página</label>
                    <input type="text" className="form-control" name="pagina_gestor" onChange={handleChange} value={formData.pagina_gestor} />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-end">
              <button type="button" className="btn btn-secondary me-2" onClick={() => setFormData({})}>
                Cancelar
              </button>
              <button type="submit" disabled={isSubmitting} className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}

export default GestorNovo;